import { extend } from 'flarum/common/extend';

/**
 * Removes two buttons from the plain (non-rich-text) composer toolbar -
 * flarum-markdown's own markdownToolbarItems() override, vendor/flarum/
 * markdown/js/src/common/index.tsx - shown when a user toggles out of
 * fof/rich-text's own editor (see removeRichTextToolbarButtons.js for the
 * same two removals there; this file only covers the plain-text fallback,
 * which has just the one 'spoiler' button and no separate block/hide
 * variant to go with it):
 *
 * - 'image' ("Ajouter une image", inserts ![]()  Markdown syntax) -
 *   clicking it would otherwise insert syntax the server no longer
 *   renders as an image at all (see the root extend.php's own Formatter
 *   configure(), which deletes the shared 'IMG' tag both [img][/img]
 *   BBCode and ![]()  Markdown target). fof/upload's own attach/upload
 *   button is a separate toolbar item entirely, untouched here - this
 *   only removes the dead link-based affordance.
 * - 'spoiler' (">! ... !<" Markdown syntax) - requested directly, still
 *   showing in this toolbar even after removeRichTextToolbarButtons.js's
 *   own spoiler_inline/spoiler_block removal, since that one only touches
 *   fof/rich-text's own separate toolbar, not this fallback one.
 */
export default function removeMarkdownComposerButtons() {
  extend('flarum/common/components/TextEditor', 'markdownToolbarItems', function (items) {
    items.remove('image');
    items.remove('spoiler');
  });
}